import { Pagination, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { PaginationMeta } from '../../../types/pagination';

interface ListBottomBarProps {
  page: number;
  meta?: PaginationMeta;
  onChange?: (e: React.ChangeEvent<unknown>, value: number) => void;
}

const ListBottomBar: React.FC<ListBottomBarProps> = ({ page, meta, onChange }) => {
  if (!meta) return null;

  const firstRecord = meta.total_count === 0 ? 0 : (page - 1) * meta.per_page + 1;
  const lastRecord = Math.min(page * meta.per_page, meta.total_count);

  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2} mt={1} flexShrink={0}>
      <Typography variant="body2" color="text.secondary">
        {firstRecord}-{lastRecord} of {meta.total_count}
      </Typography>

      {meta.total_pages > 1 && (
        <Paper elevation={0}>
          <Pagination page={page} count={meta.total_pages} onChange={onChange} />
        </Paper>
      )}
    </Stack>
  );
};

export default ListBottomBar;
